'use client';

import * as React from 'react';

import { cn } from '@/lib/utils';

const TEXT_ELEMENTS = {
  div: 'div',
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  p: 'p',
  span: 'span',
} as const;

export interface ShiningTextProps {
  as?: keyof typeof TEXT_ELEMENTS;
  className?: string;
  duration?: number;
  text: string;
}

export const ShiningText = React.memo(function ShiningText({
  as = 'span',
  className,
  duration = 3,
  text,
}: ShiningTextProps): React.JSX.Element {
  const TextElement = TEXT_ELEMENTS[as];

  return (
    <TextElement
      className={cn(
        'bg-[linear-gradient(110deg,#666,35%,#fff,50%,#666,75%,#666)] bg-size-[200%_100%] bg-clip-text text-base text-transparent motion-safe:animate-[shimmer_3s_linear_infinite_reverse] motion-reduce:bg-none motion-reduce:text-current',
        className,
        // Keep the moving gradient tied to the glyph run. Status wrappers can
        // still own full-width truncation/layout, but the shimmer itself must
        // not stretch across the entire transcript rail.
        'inline-block w-fit max-w-full'
      )}
      style={{
        animationDuration: `${duration}s`,
        backgroundPosition: '200% 0',
      }}
    >
      {text}
    </TextElement>
  );
});
